import React from "react";
import {withRouter} from "react-router-dom";

class Iframe extends React.Component {


  render() {
    return (
        <div>          
        <iframe src={this.props.src} height={this.props.height} width={this.props.width}/>         
      </div>
    )
  }
}

export default Iframe;


// WEBPACK FOOTER //
// ./src/components/HOC/iframe.js